async function fetchPost(url, body) {
  return fetch(url, {
    method: 'post',
    body: body,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then((r) => r.json());
}

export { fetchPost };

export class FormPost {
  constructor(options) {
    if (!options.form) {
      throw new Error('The "form" option is required.');
    }
    if (!options.successElement) {
      throw new Error('The "successElement" option is required.');
    }
    if (!options.errorElement) {
      throw new Error('The "errorElement" option is required.');
    }
    if (!options.captcha) {
      throw new Error('The "captcha" option is required.');
    }
    if (!options.captchaInput) {
      throw new Error('The "captchaInput" option is required.');
    }
    if (!options.submitButton) {
      throw new Error('The "submitButton" option is required.');
    }
    if (!options.postPath) {
      throw new Error('The "postPath" option is required.');
    }

    this.form = options.form;
    this.successElement = options.successElement;
    this.errorElement = options.errorElement;
    this.captcha = options.captcha;
    this.captchaInput = options.captchaInput;
    this.submitButton = options.submitButton;
    this.postPath = options.postPath;

    this.submitting = false;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      this.captchaInput.value = this.captcha.getResponse();

      this._submitForm();

      return false;
    });
  }

  _submitForm() {
    if (this.submitting) {
      return;
    }

    this.submitting = true;
    this.successElement.style.display = 'none';
    this.errorElement.style.display = 'none';
    this.submitButton.textContent = 'Submitting...';
    this.submitButton.disabled = true;

    const formData = new FormData(this.form);
    const postPath = this.postPath;

    fetchPost(postPath, formData)
      .then((r) => {
        if (r.success) {
          this.successElement.style.display = '';
          this.form.reset();
          this.form.style.display = 'none';
        } else {
          if (Array.isArray(r.errors)) {
            r.errors = this._processErrors(r.errors);
          }

          this.errorElement.innerHTML = r.errors.join('<br>');
          this.errorElement.style.display = '';
        }
      })
      .catch((e) => {
        this.errorElement.textContent = 'Something unexpected happened.';
        this.errorElement.style.display = '';
      })
      .finally(() => {
        this.submitting = false;
        this.submitButton.textContent = 'Submit';
        this.submitButton.disabled = false;
        this.captcha.reset();
      });
  }

  _processErrors(errors) {
    const globalErrors = [];

    errors.forEach((error) => {
      let errorMessage = error.message;

      //attempt to provide context to the error message
      if (error.label) {
        errorMessage = `${error.label}: ${error.message}`;
      }

      globalErrors.push(errorMessage);
    });

    return globalErrors;
  }
}
